import { Container, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface ChatWindowHeaderProps {
  title: string;
  rightContent?: ReactNode;
}

export const ChatWindowHeader = ({ title, rightContent }: ChatWindowHeaderProps) => {
  const theme = useTheme();

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.divider}`,
        width: '100%',
        padding: `${theme.spacing(4)} ${theme.spacing(6)} !important`,
      }}
    >
      <Typography variant="h6">{title}</Typography>
      {rightContent}
    </Container>
  );
};
